export default __webpack_public_path__ + "18ce126ae6fd3872ff6006f855a53902.svg";